/**
 * Recursively filter reporter metadata.
 * @param metadata Deep Metadata to filter.
 * @param reporter Reporter with filter config.
 * @param prefix Prefix for recusring nested metadata.
 * @returns Filtered metadata.
 */
export function filterReporterMetadata(metadata, reporter, prefix, depth = 0, maxDepth = 10) {
    const ignorePatterns = reporter.ignoreMetadataPatterns;
    // No metadata, or no patterns.
    if (metadata === undefined || !ignorePatterns || depth > maxDepth) {
        return metadata;
    }
    const entries = Object.entries(metadata);
    return Object.fromEntries(entries
        .filter(([key]) => {
        const fullKey = prefix ? prefix + key : key;
        return !ignorePatterns.some((pattern) => typeof pattern === 'string' ? pattern === fullKey : pattern.test(fullKey));
    })
        .map(([key, value]) => {
        if (typeof value === 'object' && value !== null) {
            const fullKey = prefix ? prefix + key : key;
            return [key, filterReporterMetadata(value, reporter, `${fullKey}.`, depth + 1, maxDepth)];
        }
        return [key, value];
    }));
}
//# sourceMappingURL=utils.js.map